import { __rest } from "tslib";
import * as React from 'react';
const ChevronRightXSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M6.70710678,4 L9.998,7.296 L10.0025063,7.2929733 L10.709613,8.00008009 L10.706,8.003 L10.708538,8.00673368 L10.0014313,8.71384046 L9.998,8.71 L6.70710678,12.0001068 L6,11.293 L9.291,8.002 L6,4.70710678 L6.70710678,4 Z" })));
};
ChevronRightXSmall.displayName = 'ChevronRightXSmall';
export default ChevronRightXSmall;
//# sourceMappingURL=ChevronRightXSmall.js.map